import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
    selector: 'app-selection-indicator-renderer',
    templateUrl: './selection-indicator-renderer.component.html',
    standalone: false
})
export class SelectionIndicatorRendererComponent implements ICellRendererAngularComp {
    isSelected: boolean = false;
    displayValue: string = '';

    agInit(params: ICellRendererParams): void {
        this.isSelected = params.node.isSelected() ?? false;
        this.displayValue = String(params.valueFormatted ?? params.value ?? '');
    }

    refresh(params: ICellRendererParams): boolean {
        this.isSelected = params.node.isSelected() ?? false;
        this.displayValue = String(params.valueFormatted ?? params.value ?? '');
        return true;
    }
}
